import React from "react"
import { Formik } from "formik"
import * as Yup from "yup"
import { useTranslation } from "react-i18next"
import { CatalogFormValues } from "../../models/catalog"
import { formTranslation } from "../../locales/form"
import { useAppSelector } from "../../store/hooks"
import FormikCatalogForm from "./FormikCatalogForm"
import "./CatalogForm.module.scss"
import { selectAllProjects, selectCurrentProject } from "../../store/projects/selectors"
import { KnowledgeBasePermission, KnowledgeBasePermittedActionSelectItem } from "../../models/knowledgeBase/permission"
import { EArticleEditFormChangesInheritance } from "../../models/article"

export interface CatalogFormProps {
    catalogTitle?: string
    isEdit?: boolean
    onCreateCatalog: (values: CatalogFormValues) => void
    onEditCatalog: (values: CatalogFormValues) => void
    onCancel: () => void
    loading?: boolean
    permissions: KnowledgeBasePermission[]
    permissionsWithNested: boolean
    permittedActionOptions: KnowledgeBasePermittedActionSelectItem[]
    disableProjectsSelector?: boolean
    disabledPermInheritance?: boolean
}

const CatalogForm: React.FC<CatalogFormProps> = props => {
    const {
        catalogTitle = "",
        isEdit,
        onCreateCatalog,
        onEditCatalog,
        onCancel,
        permissions,
        permissionsWithNested,
        permittedActionOptions,
        loading = false,
        disableProjectsSelector,
        disabledPermInheritance
    } = props

    const { t } = useTranslation()
    const currentProject = useAppSelector(selectCurrentProject)
    const projects = useAppSelector(selectAllProjects)

    return (
        <Formik<CatalogFormValues>
            initialValues={{
                Title: catalogTitle,
                Permissions: permissions,
                ChangesInheritance: permissionsWithNested
                    ? EArticleEditFormChangesInheritance.INHERIT
                    : EArticleEditFormChangesInheritance.ROOT
            }}
            validationSchema={() =>
                Yup.object().shape({
                    Title: Yup.string().requiredExcludeEmpty(formTranslation.titleRequired)
                })
            }
            onSubmit={values => (isEdit ? onEditCatalog(values) : onCreateCatalog(values))}
        >
            {formikProps => (
                <FormikCatalogForm
                    loading={loading}
                    onCancel={onCancel}
                    currentProject={currentProject}
                    projects={projects}
                    permittedActionOptions={permittedActionOptions}
                    disableProjectsSelector={disableProjectsSelector}
                    disabledPermInheritance={disabledPermInheritance}
                    isEditForm={isEdit}
                    {...formikProps}
                    t={t}
                />
            )}
        </Formik>
    )
}

export default CatalogForm
